import { render, staticRenderFns } from "./DayoffsQuantityTable.vue?vue&type=template&id=089d2723&"
import script from "./DayoffsQuantityTable.vue?vue&type=script&lang=js&"
export * from "./DayoffsQuantityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports